import TestPrice from "@/src/components/common/test-search/testPrice";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";
import Link from "next/link";

import CustomChip from "@/src/lib/ui/customChip";
import CustomTooltip from "@/src/lib/ui/customTooltip";
import TatByCity from "@/src/components/common/tat/tatByCity";

const TaggedProductCard = ({
    item,
    isSpacing = false,
    bookButtonText = "Book Now",
}) => {
    return (
        <div className={isSpacing ? "md:mx-3 mx-1" : ""}>
            <div className="group relative h-full">
                <div className="bg-white md:p-3 h-full p-2 border border-solid border-gray-300 hover:border-primary shadow-md rounded-lg">
                    <div className="flex flex-row items-start justify-between gap-2 pb-2">
                        <div className="flex-1 min-w-0">
                            <CustomTooltip
                                title={item?.productName}
                                wrapperClassName="block w-full min-w-0"
                            >
                                <h3 className="truncate text-base text-black font-bold leading-5 mb-0.5">
                                    {item?.productName}
                                </h3>
                            </CustomTooltip>
                            <p className="text-xs text-gray-600 mb-4">
                                {item?.categoryType == "scan"
                                    ? "Radiology"
                                    : item?.categoryType == "lab"
                                    ? "Pathology"
                                    : "Packages"}
                            </p>
                        </div>

                        <CustomChip
                            size="small"
                            label={item?.categoryName || item?.category}
                            variant="outlined"
                            className="text-xs flex-shrink-0"
                            color="primary"
                        />
                    </div>
                    <div>
                        <div className="flex flex-row items-center justify-between gap-2 pb-2">
                            {item?.inclusions && (
                                <>
                                    <div className="flex flex-row items-center gap-1">
                                        <Iconify
                                            icon={IconCode.paramter}
                                            width="30px"
                                            color="gray"
                                        />
                                        <div className="flex flex-col items-start">
                                            <p className="text-sm font-semibold text-gray-600">
                                                {
                                                    item?.inclusions
                                                        .inclusionCount
                                                }{" "}
                                                {item?.inclusions.inclusionType}
                                                {item?.inclusions
                                                    .inclusionCount > 1
                                                    ? "s"
                                                    : ""}
                                            </p>
                                            <p className="text-xs text-gray-600">
                                                Included
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex flex-row items-center gap-1">
                                        <Iconify
                                            icon={IconCode.reportTat}
                                            width="30px"
                                            color="gray"
                                        />
                                        <div className="flex flex-col items-start">
                                            <p className="text-sm font-semibold text-gray-600 leading-3 pb-1">
                                                Report TAT
                                            </p>

<TatByCity tat={item?.tatByCityId} className="text-xs text-gray-600"/>


                                            {/* <p className="text-xs text-gray-600">


                                                 
                                            </p> */}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="py-4">
                            <div className="flex flex-row justify-between">
                                <TestPrice
                                    price={item?.cityPrice}
                                    minPrice={item?.minPrice}
                                    maxPrice={item?.maxPrice}
                                    textColor={"text-black"}
                                />
                                <div>
                                    <Link
                                        href={`/test/${item?.urlSlug}`}
                                        className="bg-primary text-white px-4 py-2 rounded-xs font-medium text-sm hover:bg-primary/80 transition-all duration-300"
                                    >
                                        {bookButtonText}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaggedProductCard;
